var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:[
    'editorParagraph',
    `editorParagraph--${_vm.data.alignment}`,
    { 'editorParagraph--small': _vm.small },
  ],domProps:{"innerHTML":_vm._s(_vm.parseTags)}})
}
var staticRenderFns = []

export { render, staticRenderFns }